module.exports = __webpack_public_path__ + "static/media/folder-open.39e1cef1.svg";